import "./App.css";
import { useCallback } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AnnouncementPage from "./Components/AnnouncementPage/AnnouncementPage.jsx";
import LoginPage from "./Components/LoginPage/LoginPage.jsx";
import PushMessagePage from "./Components/PushMessage/PushMessage.jsx";
import SignUpPage from "./Components/SignUpPage/SignUpPage.jsx";
import OTPPage from "./Components/OTPPage/OTPPage.jsx";
import ForgetPasswordPage from "./Components/ForgetPasswordPage/ForgetPasswordPage.jsx";
import ResetPasswordPage from "./Components/ForgetPasswordPage/ResetPasswordPage.jsx";
import Homepage from "./Components/HomePage/Homepage.jsx";
import ViewMembersPage from "./Components/ViewMembersPage/ViewMembersPage.jsx";
import OnboardingPage from "./Components/OnboardingPage/OnboardingPage.jsx";
import AddMembers from "./Components/AddMembers/AddMembers.jsx";
import AddEvents from "./Components/AddEvents/AddEvents.jsx";
import HandleBookings from "./Components/HandleBookings/HandleBookings.jsx";
import Settings from "./Components/Settings/Settings.jsx";
import { getAccess, clearTokens } from "./utils/authUtils.js";
import ProtectedRoute from "./ProtectedRoute.jsx";
import ProtectedLayout from "./ProtectedLayout.jsx";
import UsefulResources from "./Components/UsefulResources/UsefulResources.jsx";

export default function App() {
  const handleLogout = useCallback(() => {
    clearTokens();
  }, []);

  //App.js should only contain routes and minimal logic
  //Routes are split into logged in users and logged out users
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/otp" element={<OTPPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />

        {/* Protected routes (everything under here requires a token) */}
        <Route element={<ProtectedRoute />}>
          {/* Layout that shows Sidebar only when authed */}
          <Route element={<ProtectedLayout onLogout={handleLogout} />}>
            {/* You can also add a redirect for "/" when authed, if someone hits it manually */}
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route
              path="/reset-password/:username"
              element={<ResetPasswordPage />}
            />
            <Route path="/home" element={<Homepage />} />
            <Route path="/announcements" element={<AnnouncementPage />} />
            <Route path="/push-message" element={<PushMessagePage />} />
            <Route path="/addmembers" element={<AddMembers />} />
            <Route path="/addevents" element={<AddEvents />} />
            <Route path="/handlebookings" element={<HandleBookings />} />
            <Route path="/usefulresources" element={<UsefulResources />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/view-members" element={<ViewMembersPage />} />
          </Route>
        </Route>

        {/* Catch-alls */}
        <Route
          path="*"
          element={
            getAccess() ? (
              <Navigate to="/home" replace />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
      </Routes>
    </div>
  );
}
